module.exports = __webpack_public_path__ + "img/category-sport-hover.00e1de84.png";